import React from 'react';
import { Route, IndexRoute } from 'react-router';

import GreyhoundRacingHomePage from './containers/GreyhoundRacingHomePage';
import GreyhoundRacingRacecards from './containers/GreyhoundRacingRacecards';
import GreyhoundRacingRacePageContainer from './containers/GreyhoundRacingRacePageContainer';
import GreyhoundRacingRacecardsForDateContainer from './containers/GreyhoundRacingRacecardsForDateContainer';
import GreyhoundRacingResultsForDateContainer from './containers/GreyhoundRacingResultsForDateContainer';
import GreyhoundRacingFastResultsPage from './containers/GreyhoundRacingFastResultsPage';
import GreyhoundRacingFastResults from './containers/GreyhoundRacingFastResults';
import GreyhoundRacingResults from './containers/GreyhoundRacingResults';

import GreyhoundRacingBase from './components/GreyhoundRacingBase';
import GreyhoundRacingRacecardPage from './components/GreyhoundRacingRacecardPage';

import ArticleContainer from 'modules/News/containers/ArticleContainer';
import Article from 'modules/News/components/Article';
import MoreNews from 'modules/News/containers/MoreNews';
import MostReadAll from 'modules/Common/containers/MostReadAll';

import SectionLink from 'modules/Common/components/SectionLink';
import RacingTips from 'modules/Common/containers/RacingTips';
import FootballTips from 'modules/Common/containers/FootballTips';
import HorseRacingNextRaceOff from 'modules/Common/containers/HorseRacingNextRaceOff';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import GptAdvert from 'modules/Common/components/GptAdvert';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';

import GreyhoundRacingNav from './nav/GreyhoundRacingNav';

import { newsArticleExpander } from 'modules/News/sitemap-helper.js';

import { resultsDateExpander,
          racecardExpander } from './sitemap-helper.js';

const GreyhoundsRHSComponents = {
  MostReadAll,
  SectionLink,
  RacingTips,
  FootballTips,
  HorseRacingNextRaceOff,
  AdvertWrapper,
  GptAdvert,
  GooglePublisherTag
}

const GreyhoundsRHSComponentsWithMostRead = {
  MostReadAll,
  ...GreyhoundsRHSComponents
}          

const greyhoundRacingRoutes = (
  <Route path="greyhounds" component={GreyhoundRacingBase} subnav={GreyhoundRacingNav}>
    <Route component={GreyhoundRacingHomePage}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={{MoreNews, ...GreyhoundsRHSComponentsWithMostRead}}/>
    </Route>
    <Route path="racecards" component={GreyhoundRacingRacecards}> {/*Has Layout Manager*/}
      <IndexRoute components={{GreyhoundRacingRacecardsForDateContainer, ...GreyhoundsRHSComponents}}/> {/*Has Layout*/}
      <Route path=":date/:courseSlug" components={{GreyhoundRacingRacePageContainer, ...GreyhoundsRHSComponents}}> {/*Has Layout*/}
        <Route path="racecard/:raceId" sitemap={{changefreq: "always", priority: 0.5, expand: racecardExpander}} component={GreyhoundRacingRacecardPage} />
      </Route>
    </Route>
    <Route path="fast-results" component={GreyhoundRacingFastResultsPage}>
      <IndexRoute sitemap={{}} components={{GreyhoundRacingFastResults, ...GreyhoundsRHSComponents}}/>
    </Route>
    <Route path="results" component={GreyhoundRacingResults}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={{GreyhoundRacingResultsForDateContainer, ...GreyhoundsRHSComponents}}/> {/*Has Layout*/}
      <Route path=":date" sitemap={{expand: resultsDateExpander}} components={{GreyhoundRacingResultsForDateContainer, ...GreyhoundsRHSComponents}}/> {/*Has Layout*/}
    </Route>
    <Route path="news/:title/:articleId"
           component={ArticleContainer}
           sport="greyhounds"
           rightHandContent={['mostReadAll', 'topMpu', 'ocWidget', 'racingTips', 'horseRacingNextRaceOff', 'footballTips', 'bottomMpu']}> {/* layout manager */}
      <IndexRoute sitemap={{expand: newsArticleExpander("greyhounds")}} components={{ Article, ...GreyhoundsRHSComponentsWithMostRead }}/> {/* layout */}
    </Route>
  </Route>
)

export default greyhoundRacingRoutes;



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/routes.js